<template>
    <page-header titolo="Gestione documenti" icona="fa-video" sfondo="bkg-servizi1"></page-header>
    
    <div class="pol-container">

        <!-- **** GRIGLIA **** -->
        <div class="card" v-if="mostraGriglia">
            <div class="card-body">

                <button type="button" class="btn btn-newDoc" @click="NuovoDocumento(1)" :style="'background-color:' + BtnBkgColor(1)">
                    <font-awesome-icon icon="fa-solid fa-plus"></font-awesome-icon>&nbsp;Nuovo DVR
                </button>
                <br /><br />

                <div class="d-flex justify-content-start">
                    <div class="form-group mx-2 ">
                        <label>Ricerca testuale</label>
                        <input type="text" class="form-control form-control-sm" placeholder="cerca per ..." v-model="reqGrigliaDocumenti.Testuale" @keyup.enter="GetListDocumenti" />
                    </div>
                    <div class="form-group mx-2">
                        <label>Cliente</label>
                        <!-- <select class="form-control form-control-sm"></select> -->
                        <select-cercabile
                            :dati="dtClientiSelect"
                            :multiselect="false"
                            :SetSelected="[['','Seleziona...']]"


                            
                            @selezionato="GrigliaClienteSel"
                        ></select-cercabile>
                        <!--
                            [[0, 'test'],[1, 'test 2'], [2, 'opzione 3']] 
                            <button type="button" @click="testSelect = [[0,'test']]">Test</button> -->
                    </div>
                    <div class="from-group mx-2">
                        <br />
                        <a class="btn btn-sm btn-dark" @click="AzzeraFiltri" >
                        <font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>&nbsp;Azzera
                        </a>&nbsp;
                        <a class="btn btn-sm btn-info" @click="GetListDocumenti" >
                        <font-awesome-icon icon="fa-solid fa-search"></font-awesome-icon>&nbsp;Cerca
                        </a>
                    </div>
                </div>  
                <div class="form-group" style="margin-top:10px; margin-bottom:5px;">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="reqGrigliaDocumenti.Obsoleti" @change="GetListDocumenti"  />&nbsp;Mostra documenti OBSOLETI
                        </label>
                    </div>

                </div>
                
                <br/>
                <griglia-facile
                    :colonne-header="g_colonneHeader"
                    :colonne="g_colonne"
                    :colonneNoOrder="g_colonneNoOrder"
                    :comandi="g_comandi"
                    :mostraPager="true"
                    classi-table="table-sm table-hover"
                    :dati="dtVS_Documenti"
                    :queryLength="g_queryLength"
                    :currentPage="g_currentPage"
                    
                    @Seleziona="GetDocumento"
                    @Cancella="DelDocumento"
                    @Ordina="OrdinaGriglia"
                    @Disattiva="DisattivaUtente"
                    @CambiaElementi="CambiaElementi"
                    @Precedente="PaginaPrecendente"
                    @Successiva="PaginaSuccessiva"
                    @CambiaPagina="CambiaPagina"

                    @Duplica="DuplicaDocumento"
                    @Stato="StatoDocumento"
                    

                    ></griglia-facile>



            </div>
        </div>

        <!-- **** DVR **** -->
        <div class="card" v-if="mostraDVR">
            <div class="card-header">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaPannello('doc_-1')">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocumento(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocumento(false)">Salva e Chiudi</button>
            </div>
            <div class="card-body">

                <div class="alert alert-warning m-3" v-if="oDocumento.doc_chiuso">
                    ATTENZIONE. Questo documento è OBSOLETO.
                </div>

                <form autocomplete="off">
                <!-- <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <font-awesome-icon icon="fa-solid fa-info" class="text-primary"></font-awesome-icon>&nbsp;Dati generali
                    </div>
                </div> -->

                <messaggio-std 
                    :mostraMessaggio="msgDocMostra"
                    alertClass="alert alert-warning"
                    alertIcon="fas fa-times"
                    :alertMessaggio="msgDocMessaggio"
                    alertIconSpin="false"
                    
                />

                

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Tipo</label>
                            <select class="form-control" v-model="oDocumento.doc_idTipo" disabled>
                                <option v-for="o in dtDocumentiTipo" :key="o.dtp_id" :value="o.dtp_id">{{ o.dtp_titolo }}</option>
                            </select>

                        </div>

                    </div>  
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Categoria</label>
                            <select class="form-control" v-model="oDocumento.doc_idCategoria">
                                <template v-for="o in dtDocumentiCategoria" :key="o.dtc_id">
                                    <option v-if="o.dtc_idTipo == oDocumento.doc_idTipo" :value="o.dtc_id">{{ o.dtc_titolo }}</option>
                                </template>
                                
                            </select>
                        </div>

                    </div>
                </div>
                
                <div class="form-group">
                    <label>Cliente</label>
                    <select-cercabile
                            :dati="dtClientiSelect"
                            :multiselect="false"
                            :SetSelected="[[oDocumento.doc_CodCliFor, oDocumento.cli_DesCliFor]]"
                          
                            @selezionato="SelezionaClienteForm"
                        ></select-cercabile>
                </div>
                
                <div class="form-group">
                    <label>Descrizione</label>
                    <input type="text" class="form-control" v-model="oDocumento.doc_descrizione">
                </div>

                <div class="form-group">
                    <label>Note avanzamento lavori</label>
                    <textarea class="form-control" v-model="oDocumento.doc_note_avanzamento"></textarea>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Data documento</label>
                            <input type="date" class="form-control" v-model="oDocumento.doc_dataDoc">
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Scadenza</label>
                            <select class="form-control" v-model="oDocumento.anniScadenza" @change="CalcolaScadenza" >
                                <option value="0">Nessuna scadenza</option>
                                <option value="1">1 anno</option>
                                <option value="2">2 anni</option>
                                <option value="3">3 anni</option>
                                <option value="4">4 anni</option>
                                <option value="5">5 anni</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Data scadenza</label>
                            <input type="date" class="form-control" v-model="oDocumento.dataScadenza">
                        </div>
                    </div>

                </div>
                

                <div class="form-group" style="margin-top:10px; margin-bottom_10px:">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="oDocumento.creaScadenza"  />&nbsp;Crea automaticamente la scadenza nello scadenzario (se specificata)
                        </label>
                    </div>

                </div>

                <div class="form-group" style="margin-top:10px; margin-bottom_10px:" v-if="oDocumento.doc_id != -1">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="oDocumento.doc_chiuso"  />&nbsp;Documento OBSOLETO
                        </label>
                    </div>

                </div>
                
                <!-- *** ALLEGATI *** -->
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <font-awesome-icon icon="fa-solid fa-paperclip" class="text-dark"></font-awesome-icon>&nbsp;Allegati
                    </div>
                </div>
                <div v-if="oDocumento.doc_id != -1">
                    <form :action="cfg.apisrv + '/api/Allegati/UploadFile'" method="POST" enctype="multipart/form-data" target="iFrameUp">
                    <input type="file" name="FileBin" class="btn btn-outline-secondary" multiple="multiple" /><!-- @click="InitCaricamento"-->
                    <input type="hidden" name="FileToken" v-model="oDocumento.token" />&nbsp;
                    <input type="hidden" name="FileIdTabella" value="1" />&nbsp;
                    <input type="hidden" name="FileIdOggetto" v-model="oDocumento.doc_id" />&nbsp;
                    <button type="submit" class="btn btn-primary">Carica</button>
                    </form>
                </div>
                <div v-else>
                    <h3>Per caricare gli allegati salvare il documento</h3>
                </div>
                <div v-if="mostraCaricato">
                    <font-awesome-icon icon="fa-solid fa-check" size="2x" class="comandi-positivo" />&nbsp;<strong>File caricati!</strong>
                </div>
                <iframe id="iFrameUp" name="iFrameUp" style="display: none;" @load="iFrameLoad"></iframe> <!--  -->
                <br />

                <table class="table table-sm table-hover tblPoliDoc" v-if="oDocumento.doc_id != -1">
                    <thead>
                    <tr>
                        <th></th>
                        <th>Nome file</th>
                        <th>Note</th>
                        <th>Dim. KB</th>
                        <th>Caricato</th>
                        <th>Azioni</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="a in dtAllegati" v-bind:key="a">
                            <!-- <td><img style="width:32px;" :src="'img/icone_file/' + a.icona[0]" :alt="a.icona[1]" /></td> -->
                            <!-- ICONA: Immagine o documento-->
                            <td v-if="a.all_tipoAllegato==1"><a target="_blank" :href="cfg.apisrv + '/api/Allegati/GetImage?token=' + $store.state.UserInfo.token + '&qsImmagine=documenti\\'+ a.all_nomeFile"><img style="width:32px;" :src="cfg.RootPath + '/img/icone_file/' + a.icona[0]" :alt="a.icona[1]" /></a></td>
                            <td v-else><a target="_blank" :href="cfg.apisrv + '/api/Allegati/GetFile?token=' + $store.state.UserInfo.token + '&nome=documenti\\'+ a.all_nomeFile +'&nomeOrig=' + a.all_nomeFileOriginale"><img style="width:32px;" :src="cfg.RootPath + '/img/icone_file/' + a.icona[0]" :alt="a.icona[1]" /></a></td>
                            <!-- NOME FILE-->
                            <td v-if="!a.edit">{{ a.all_nomeFileOriginale }}</td>
                            <td v-else>
                                <input type="text" class="form-control" v-model="a.all_nomeFileOriginale">
                            </td>
                            <!-- DESCRIZIONE/NOTE-->
                            <td v-if="!a.edit">{{a.all_descrizione}}</td>
                            <td v-else>
                                <input type="text" class="form-control" v-model="a.all_descrizione">
                            </td>
                            <td>{{a.all_dimensione}}</td>
                            <td>{{a.dataCreazione}}</td>
                            <td>
                                <button type="button" class="btn btn-sm btn-outline-danger" @click="CancellaAllegato(a)" title="Cancella">
                                    <font-awesome-icon icon="fa-solid fa-trash"></font-awesome-icon>
                                </button> &nbsp;
                                <template v-if="!a.edit">
                                    <button type="button" class="btn btn-sm btn-outline-warning" @click="EditNoteAllegato(a)" title="Modifica allegato">
                                        <font-awesome-icon icon="fa-solid fa-edit"></font-awesome-icon>
                                    </button> 
                                </template>
                                <template v-else>
                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="SalvaNoteAllegato(a)" title="Salva modifiche">
                                        <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>
                                    </button> 
                                </template>
                                
                            </td>
                        </tr>
                    </tbody>
                    

                </table>

                
            </form>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaPannello('doc_-1')">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocumento(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocumento(false)">Salva e Chiudi</button>
            </div>
        </div>

    </div>

    
  


</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import GrigliaFacile from '@/components/GrigliaFacile.vue';
import SelectCercabile from '@/components/SelectCercabile.vue';
import snFunctions from '@/lib/snFunctions.js';
import MessaggioStd from '@/components/MessaggioStandard.vue';


export default {
    name:"DocumentiView",
    components: {PageHeader, GrigliaFacile, SelectCercabile, MessaggioStd},
    inject: ['cfg'],
    data: function() {
        return {
            iddoc: this.$route.params.iddoc,
            idtipo: this.$route.params.idtipo,

            dtVS_Documenti: [],

            dtClienti: [],
            dtClientiSelect: [],

            dtDocumentiTipo: [],
            dtDocumentiCategoria: [],

            dtAllegati: [],

            //Impostazioni griglia DOCUMENTI
            g_colonne: ['doc_id','doc_dataDoc', 'dtp_titolo','dtc_titolo', 'doc_descrizione','cli_DesCliFor', 'dataScadenza', 'stato'],
            g_colonneHeader: ['Id', 'Data doc.', 'Tipo', 'Categoria', 'Descrizione', 'Cliente', 'Scad.', 'Stato'],
            g_colonneNoOrder: [], 
            g_comandi: 
            [
                {titolo:'Modifica', icona:'fa-edit', iconaStile: 'btn btn-sm btn-outline-info', emetti: 'Seleziona'},
                {titolo:'Cancella', icona:'fa-trash', iconaStile: 'btn btn-sm btn-outline-danger', emetti: 'Cancella'},
                {titolo:'Duplica', icona:'fa-copy', iconaStile: 'btn btn-sm btn-outline-info', emetti: 'Duplica'},
                {titolo:'Cambia stato', icona:'fa-stamp', iconaStile: 'btn btn-sm btn-outline-secondary', emetti: 'Stato'}
            ],
            g_queryLength: 0, //lunghezza della query (che NON è la lunghezza del dataset passato)
            g_currentPage: 1, //pagina corrente

            //Oggetto richiesta griglia
            reqGrigliaDocumenti: {
                ele_pag: 10,
                start: 0,
                orderColumn: "doc_dataDoc",
                orderDir:"DESC",
                token: "",
                //Campi custom
                Testuale: "",
                Cliente: "",
                Obsoleti: false,
            },

            mostraGriglia: true,
            mostraDVR: false,

            //caricamento allegati
            mostraCaricato: false,
            initLoad: 0,

            //Oggetto documento
            oDocumento: {
                doc_id : -1, 
                doc_idTipo : 1,
                doc_CodCliFor : '',
                cli_DesCliFor : 'Seleziona',
                doc_note_avanzamento: "",

                token: "",
                
            },

          

            msgDocMostra: false,
            msgDocMessaggio: [''],


        }
    },
    methods: {
        //*** GRIGLIA DOCUMENTI *** */

        //recupera il colore del tipo doc per colorarew lo sfondo del bottone Nuovo documnento
        BtnBkgColor(idTp) {
            for(let i = 0; i< this.dtDocumentiTipo.length; i++) {
                if(this.dtDocumentiTipo[i].dtp_id == idTp) {
                    return this.dtDocumentiTipo[i].dtp_colore;
                }
            }

            return "#ccc";
        },
       
        // lista documenti
        GetListDocumenti() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento griglia in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Documenti/GetListDocumenti" , {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.reqGrigliaDocumenti)
            }).then(response => response.json())
            .then(obj => {
                if(obj.status == "OK") {
                    this.dtVS_Documenti = obj.moreJsonData;
                    this.g_queryLength = parseInt(obj.dati[0], 10);
                    if(this.reqGrigliaDocumenti.Testuale != "") this.EvidenzaRicerca();

                    //Formattazioni speciali
                    for(let i = 0; i<this.dtVS_Documenti.length; i++){
                        //Mette il box colorato del tipo
                        this.dtVS_Documenti[i].dtp_titolo = 
                            "<div class='divMiniBox' style='background-color: " + this.dtVS_Documenti[i].dtp_colore + "'></div> " + 
                            this.dtVS_Documenti[i].dtp_titolo;
                        //formatta la data documento
                        this.dtVS_Documenti[i].doc_dataDoc = snFunctions.dateFormat(this.dtVS_Documenti[i].doc_dataDoc, 'dd-MM-yyyy');
                        //formatta la data scadenza
                        if(this.dtVS_Documenti[i].dataScadenza != "") {
                            this.dtVS_Documenti[i].dataScadenza = snFunctions.dateFormat(this.dtVS_Documenti[i].dataScadenza, 'dd-MM-yyyy');
                            if(this.dtVS_Documenti[i].documentoScaduto) {
                                this.dtVS_Documenti[i].dataScadenza = "<div class='div-box-warning'>" + this.dtVS_Documenti[i].dataScadenza + "</div>" ;
                            }
                        }
                        //evidenza l'obsolescenza
                        if(this.dtVS_Documenti[i].doc_chiuso) {
                            this.dtVS_Documenti[i].stato = "<span class='text-warning'>" + this.dtVS_Documenti[i].stato + "</span>";
                        } 
                        
                    }


                    this.$store.commit('Messaggio', {parms: [true, ['Griglia caricata.'], 'alert alert-success', 'fa-check', false, 2000]});
                } else {
                    this.$store.commit('Messaggio', {parms: [true, ['Errore caricamento griglia.'], 'alert alert-danger', 'fa-times', false, 2000]});
                }
                
            });
        },
        GetDocumento(o, tipo, duplica) {
            this.initLoad = 0;
            if(tipo == undefined) tipo = -1;
            if(duplica == undefined) duplica = false
            this.AttivaPannello('doc_' + o.doc_idTipo);
            this.$store.commit('Messaggio', {parms: [true, ['Recupero dati in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Documenti/GetDocumento?token=" + this.$store.state.UserInfo.token + "&idDoc=" + o.doc_id)
            .then(response => response.json())
            .then(obj => {

                if(duplica) obj.doc_id = -1
                
                if(obj.doc_dataDoc != undefined && obj.doc_dataDoc != '1970-01-01') {
                    obj.doc_dataDoc = snFunctions.dateFormat(obj.doc_dataDoc, "yyyy-MM-dd"); //formatta la data per il campo input
                } else {
                    obj.doc_dataDoc = undefined;
                }
               
                this.oDocumento = obj;
                if(tipo >= 0) this.oDocumento.doc_idTipo = tipo;

                //Carica gli allegati
                if(!duplica) this.GetListAllegati(o.doc_id);
                

                this.$store.commit('Messaggio', {parms: [true, ['Dati caricati.'], 'alert alert-success', 'fa-check', false, 2000]});
              
            });
        },
        DelDocumento(o) {
            //Cancella elemento singolo
            if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv +"/api/Documenti/DelDocumento?token=" + this.$store.state.UserInfo.token + "&idDoc=" + o.doc_id)
                .then(response => response.json())
                .then(obj => {
                    this.GetListDocumenti();
                });
            }

        },
        NuovoDocumento(tipo) {
            this.GetDocumento({ 
                doc_id : -1, 
                doc_idTipo : tipo,
            }, tipo);
            
        },
        DuplicaDocumento(o) {
            if(confirm("Duplicare l'elemento?\n\nNella copia NON verranno riportati gli allegati.")) {
               this.GetDocumento(o, o.doc_idTipo, true);
            }
        },
        StatoDocumento(o) {
            let messaggio = "";
            if(o.doc_chiuso) messaggio = "Vuoi RIPRISTINARE il documento?";
            else messaggio = "Vuoi rendere il documento OBSOLETO?";
            if(confirm(messaggio)) {
                fetch(this.cfg.apisrv +"/api/Documenti/StatoDocumento?token=" + this.$store.state.UserInfo.token + "&idDoc=" + o.doc_id + "&setStato=" + !o.doc_chiuso)
                .then(response => response.json())
                .then(obj => {
                    this.GetListDocumenti();
                });
               
            }
        },
        SalvaDocumento(reload) {
            let oSubmit = [];
            oSubmit = this.oDocumento;
            oSubmit.token = this.$store.state.UserInfo.token;

            this.msgDocMostra = false;
            fetch(this.cfg.apisrv +"/api/Documenti/SalvaDocumento", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});

                        if(reload)  {
                            //this.GetDocumento(this.oDocumento, this.oDocumento.doc_idTipo)
                            this.oDocumento.doc_id = obj.dati[0];
                        }
                        else {
                            //Fa redirect
                            this.GetListDocumenti();
                            this.AttivaPannello('doc_-1');
                            
                        }
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errori nel form.'], 'alert alert-warning', 'fa-times', false, 3000]});
                        this.msgDocMostra = true;
                        this.msgDocMessaggio = obj.dati;
                    }
                });

        },
        SelezionaClienteForm(o) {
            
            this.oDocumento.doc_CodCliFor=o[0][0];
            this.oDocumento.cli_DesCliFor=o[0][1];
        },


        CalcolaScadenza() {
            if(this.oDocumento.doc_dataDoc != undefined) {
                let dtaDoc = new  Date(this.oDocumento.doc_dataDoc.substring(0,4), this.oDocumento.doc_dataDoc.substring(5,7) -1, this.oDocumento.doc_dataDoc.substring(8,10));
                let dtaScad = dtaDoc;
                dtaScad.setFullYear(dtaScad.getFullYear() + parseInt(this.oDocumento.anniScadenza,10));
                //alert(dtaScad.getFullYear() + '-' + parseInt(dtaScad.getMonth() + 1, 10) + '-' + dtaScad.getDate())
                //this.oDocumento.dataScadenza = dtaScad.getFullYear() + '-' + parseInt(dtaScad.getMonth() + 1, 10) + '-' + dtaScad.getDate();
                this.oDocumento.dataScadenza = snFunctions.dateFormat(dtaScad, "yyyy-MM-dd");
            }
            else { 
                this.$store.commit('Messaggio', {parms: [true, ['Data documento mancante.'], 'alert alert-danger', 'fa-times', false, 2000]});
            }
            

        },
        


        //*** ALLEGATI *** */
        //Carica la lista degli allegati del documento corrente
        GetListAllegati(id) {
            let idd =  this.oDocumento.doc_id;
            if(id != undefined) idd = id;  //Se il parametro è passato forza ad usare quello
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Allegati/GetListAllegati?token=" + this.$store.state.UserInfo.token + "&idTab=1&idOgg=" + idd)
            .then(response => response.json())
            .then(obj => {
                this.dtAllegati = obj;
                //Formattazioni speciali
                for(let i = 0; i<this.dtAllegati.length; i++){
                    //formatta la data
                    this.dtAllegati[i].dataCreazione = snFunctions.dateFormat(this.dtAllegati[i].all_dataCreazione, 'dd-MM-yyyy');
                    //formatta dimensione
                    this.dtAllegati[i].all_dimensione = Math.ceil(this.dtAllegati[i].all_dimensione/1024) + ' ';
                }
            });

        },
        CancellaAllegato(a) {
            if(confirm("Vuoi cancellare l'allegato " + a.all_nomeFileOriginale + "?")) {
                fetch(this.cfg.apisrv + "/api/Allegati/DelAllegato?token=" + this.$store.state.UserInfo.token + "&guid=" + a.all_nomeFile)
                .then(response => response.json())
                .then(obj => {
                    this.GetListAllegati();
                });
            

            }

        },
        EditNoteAllegato(a) {
            a.edit=true;
        },
        SalvaNoteAllegato(a) {
            let oSubmit = [];
            oSubmit = a;
            oSubmit.token = this.$store.state.UserInfo.token;

            this.msgDocMostra = false;
            fetch(this.cfg.apisrv +"/api/Allegati/SalvaAllegato", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});

                        this.GetListAllegati();
                       
                    }
                    else {
                        
                    }
                });
            
        },

        //*** OPERAZIONI GENERALI *** */
        AttivaPannello(pnl) {
            if(pnl=='doc_-1') {
                this.GetListDocumenti();

                this.mostraGriglia = true;
                this.mostraDVR = false;
                this.msgDocMostra = false;
            }
            if(pnl=='doc_1') {
                this.mostraGriglia = false;
                this.mostraDVR = true;
                this.msgDocMostra = false;
            }
        },

        GrigliaClienteSel(sel) {
            this.reqGrigliaDocumenti.Cliente = sel[0][0];
        },

        AzzeraFiltri() {
            this.reqGrigliaDocumenti.Testuale = "";
            this.reqGrigliaDocumenti.Cliente = "";

        },

        //*** GESTIONE IFRAME */
        iFrameLoad(event) {
            let _self = this;
            if(this.initLoad != 0) {
                this.mostraCaricato = true;
                window.setTimeout(() => {
                    _self.mostraCaricato = false;
                }, 3000);
            }
            this.initLoad++;

            window.setTimeout(() => {
                _self.GetListAllegati();
            }, 500);
            
            //console.log(parm1);
        },

        //*** CARICAMENTO TABELLE SERVIZIO  *** */
        GetListClienti() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Documenti/GetListClienti?token=" +  this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtClienti = obj;
                    for(let i = 0; i<this.dtClienti.length; i++) {
                        this.dtClientiSelect.push([this.dtClienti[i].cli_CodCliFor, this.dtClienti[i].cli_DesCliFor])
                    }
                });
        },
        GetListDocumentiTipo() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Documenti/GetListDocumentiTipo?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtDocumentiTipo = obj;
                });
        },
        GetListDocumentiCategoria() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Documenti/GetListDocumentiCategoria?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtDocumentiCategoria = obj;
                });
        },


        //PAGINAZIONE GRIGLIA
        CambiaElementi(nrElem) {
            this.reqGrigliaDocumenti.ele_pag = nrElem;
            this.GetListDocumenti();
        },
        PaginaPrecendente() {
            this.reqGrigliaDocumenti.start = this.reqGrigliaDocumenti.start - parseInt(this.reqGrigliaDocumenti.ele_pag, 10);
            this.g_currentPage--;
            this.GetListDocumenti();  
        
        },
        PaginaSuccessiva() {
            this.reqGrigliaDocumenti.start = this.reqGrigliaDocumenti.start + parseInt(this.reqGrigliaDocumenti.ele_pag, 10);
            this.g_currentPage++;
            this.GetListDocumenti();
        
        },
        CambiaPagina(pag) {
            this.reqGrigliaDocumenti.start = (parseInt(this.reqGrigliaDocumenti.ele_pag, 10) * pag) - parseInt(this.reqGrigliaDocumenti.ele_pag, 10);
            this.g_currentPage = pag;
            this.GetListDocumenti();
        },
       

    },
    computed: {
        

    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.reqGrigliaDocumenti.token = this.$store.state.UserInfo.token;

        this.GetListClienti();
        this.GetListDocumenti();
        this.GetListDocumentiTipo();
        this.GetListDocumentiCategoria();

        if(this.iddoc != "") {
            //Apre il documento specificato dall'esterno
            this.GetDocumento({"doc_id":this.iddoc, "doc_idTipo": this.idtipo}, this.idtipo);
        }
    }
}
</script>

<style scoped>

button.btn-newDoc {
    color: #fff;

}
button.btn-newDoc:hover {
    color: #ccc;
}


</style>